(function () {
  class VideoTestimonialsReelController {
    constructor(section) {
      this.section = section;
      this.track = section.querySelector('[data-video-reel-track]');
      this.videos = Array.from(section.querySelectorAll('.video-testimonials-reel__video'));
      this.playButtons = Array.from(section.querySelectorAll('[data-video-reel-play]'));
      this.toggleButtons = Array.from(section.querySelectorAll('[data-video-reel-toggle]'));
      this.prevButton = section.querySelector('[data-video-reel-prev]');
      this.nextButton = section.querySelector('[data-video-reel-next]');
      this.desktopMediaQuery = window.matchMedia('(min-width: 750px)');

      this.bindVideoControls();
      this.bindNavigation();
      this.updateNavigationState();
    }

    bindVideoControls() {
      this.playButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();

          const media = button.closest('.video-testimonials-reel__media');
          const video = media?.querySelector('.video-testimonials-reel__video');
          if (!(video instanceof HTMLVideoElement)) return;

          this.playVideo(video);
        });
      });

      this.toggleButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
          event.stopPropagation();

          const media = button.closest('.video-testimonials-reel__media');
          const video = media?.querySelector('.video-testimonials-reel__video');
          if (!(video instanceof HTMLVideoElement)) return;

          if (video.paused) {
            this.playVideo(video);
          } else {
            video.pause();
          }
        });
      });

      this.videos.forEach((video) => {
        const media = video.closest('.video-testimonials-reel__media');
        if (!(media instanceof HTMLElement)) return;

        const syncState = () => {
          media?.classList.toggle('is-playing', !video.paused && !video.ended);
          if (video.paused || video.ended) {
            video.controls = false;
          } else {
            video.controls = true;
          }
        };

        video.addEventListener('play', syncState);
        video.addEventListener('pause', syncState);
        video.addEventListener('ended', syncState);

        syncState();
      });
    }

    playVideo(video) {
      if (!(video instanceof HTMLVideoElement)) return;

      this.pauseOtherVideos(video);
      video.controls = true;
      video.play().catch(() => {});
    }

    pauseOtherVideos(activeVideo) {
      this.videos.forEach((video) => {
        if (video !== activeVideo) {
          video.pause();
          video.controls = false;
        }
      });
    }

    bindNavigation() {
      if (!(this.track instanceof HTMLElement)) return;

      const scrollByStep = (direction) => {
        if (!this.desktopMediaQuery.matches) return;
        const firstCard = this.track.querySelector('.video-testimonials-reel__card');
        if (!(firstCard instanceof HTMLElement)) return;

        const styles = window.getComputedStyle(this.track);
        const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
        const step = firstCard.offsetWidth + gap;

        this.track.scrollBy({
          left: direction * step,
          behavior: 'smooth'
        });
      };

      this.prevButton?.addEventListener('click', () => scrollByStep(-1));
      this.nextButton?.addEventListener('click', () => scrollByStep(1));

      this.track.addEventListener('scroll', () => this.updateNavigationState(), { passive: true });
      window.addEventListener('resize', () => this.updateNavigationState());

      const mediaChangeHandler = () => this.updateNavigationState();
      if (typeof this.desktopMediaQuery.addEventListener === 'function') {
        this.desktopMediaQuery.addEventListener('change', mediaChangeHandler);
      } else if (typeof this.desktopMediaQuery.addListener === 'function') {
        this.desktopMediaQuery.addListener(mediaChangeHandler);
      }
    }

    updateNavigationState() {
      if (!(this.track instanceof HTMLElement)) return;

      const isDesktop = this.desktopMediaQuery.matches;
      const maxScrollLeft = Math.max(this.track.scrollWidth - this.track.clientWidth, 0);
      const currentScrollLeft = this.track.scrollLeft;

      if (this.prevButton instanceof HTMLButtonElement) {
        this.prevButton.disabled = !isDesktop || currentScrollLeft <= 4;
      }

      if (this.nextButton instanceof HTMLButtonElement) {
        this.nextButton.disabled = !isDesktop || currentScrollLeft >= maxScrollLeft - 4;
      }
    }
  }

  const init = () => {
    document.querySelectorAll('.video-testimonials-reel-section').forEach((section) => {
      if (section.dataset.videoReelReady === 'true') return;
      section.dataset.videoReelReady = 'true';
      new VideoTestimonialsReelController(section);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
